import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { User } from '@/types/user'

export function getDeletedUsers(): Promise<AxiosResponse<User[]>> {
  return instance.get(`/iam/user/deleted`)
}
